"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10,2.52a.5.5,0,0,0,.5-.5V1a.5.5,0,0,0-1,0V2A.5.5,0,0,0,10,2.52Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.35,4.35a.5.5,0,0,0,0-.71l-1-1a.5.5,0,0,0-.71.71l1,1A.5.5,0,0,0,4.35,4.35Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.35,4.35l1-1a.5.5,0,1,0-.71-.71l-1,1a.5.5,0,0,0,.71.71Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2,9.52H1a.5.5,0,0,0,0,1H2a.5.5,0,0,0,0-1Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.23,12.73a7,7,0,0,1,8.88-4.9A6.49,6.49,0,1,0,4.85,14,6.46,6.46,0,0,1,7.23,12.73Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.85,16.5A3.5,3.5,0,0,0,19.45,12,6,6,0,0,0,8.07,13.56,5.5,5.5,0,0,0,9,24.48H20a4.5,4.5,0,0,0,2.85-8Z",
    fill: "#004864"
  }));
};

exports["default"] = _default;